import React from 'react';
import { Button, Result, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';

const PermissionsUnavailable: React.FC = () => {
  const { retryIdentity, logout } = useAuthStore();
  const navigate = useNavigate();

  const signInAgain = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <Result
      status="warning"
      title="Couldn't load your permissions"
      subTitle="This is a loading problem, not a change to your access. You can retry, or sign in again."
      extra={
        <Space>
          <Button type="primary" onClick={() => { void retryIdentity(); }}>
            Retry
          </Button>
          <Button onClick={() => { void signInAgain(); }}>
            Sign in again
          </Button>
        </Space>
      }
    />
  );
};

export default PermissionsUnavailable;
